import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createAtmModel = ( {data} : {data: IPostNewAtmModel | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/AtmModels/InsertAtmModel`, data);
};

type QueryFnType = typeof createAtmModel;

type UseCreateAtmModelOptions = {
  data: IPostNewAtmModel | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateAtmModel = ({ config }: UseCreateAtmModelOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Μοντέλου.`, 500);
            console.error('Couldnt create new atm model', error);
            setIsNotificationVisible(true)
          },
          onSuccess: (response) => {
            queryClient.invalidateQueries(["getAllAtmModels"])
            addNotification("Δημιουργήθηκε Νέο Μοντέλο.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createAtmModel,
    })
}